// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App-specific styles - Fairway AI Golf Dashboard */

/* Landing page hero */
.hero-section {
  min-height: 100vh;
  background: linear-gradient(to bottom, hsl(60 5% 96%), hsl(60 5% 92%));
  position: relative;
  overflow: hidden;
}

.hero-image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(245, 245, 244, 0.4) 50%,
    hsl(60 5% 96%) 100%
  );
  z-index: 1;
}

/* Dashboard layout */
.dashboard-container {
  min-height: 100vh;
  background: hsl(60 5% 96%);
}

/* Nav styling */
.nav-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  font-weight: 500;
  color: hsl(30 6% 35%);
  transition: background-color 0.2s ease, color 0.2s ease;
}

.nav-link:hover {
  background: hsl(60 5% 92%);
  color: hsl(145 80% 20%);
}

.nav-link.active {
  background: hsl(145 80% 20%);
  color: white;
}

/* Mobile bottom nav */
.mobile-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-top: 1px solid hsl(30 6% 85%);
  z-index: 40;
  padding: 0.5rem;
  padding-bottom: calc(0.5rem + env(safe-area-inset-bottom));
}

.mobile-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem;
  font-size: 0.75rem;
  color: hsl(30 6% 35%);
  transition: color 0.2s ease;
}

.mobile-nav-item.active {
  color: hsl(145 80% 20%);
}

/* Stat cards */
.handicap-card {
  grid-column: span 2;
  background: linear-gradient(135deg, hsl(145 80% 20%) 0%, hsl(145 60% 25%) 100%);
  color: white;
}

.handicap-value {
  font-family: 'JetBrains Mono', monospace;
  font-size: 4rem;
  font-weight: 700;
  line-height: 1;
}

/* Score entry form */
.score-input {
  font-family: 'JetBrains Mono', monospace;
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
  width: 100%;
  max-width: 8rem;
  padding: 1rem;
  border-radius: 1rem;
  border: 2px solid hsl(30 6% 85%);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.score-input:focus {
  outline: none;
  border-color: hsl(145 80% 20%);
  box-shadow: 0 0 0 4px hsla(145 80% 20% / 0.1);
}

/* Chart styling */
.chart-container {
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  border: 1px solid hsl(30 6% 90%);
}

/* Score history table */
.score-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: white;
  border-bottom: 1px solid hsl(30 6% 92%);
  transition: background-color 0.2s ease;
}

.score-row:hover {
  background: hsl(60 5% 98%);
}

.score-row:last-child {
  border-bottom: none;
}

/* Score badge */
.score-badge {
  font-family: 'JetBrains Mono', monospace;
  font-weight: 600;
  padding: 0.375rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
}

/* Empty state */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
}

.empty-state-icon {
  width: 4rem;
  height: 4rem;
  margin-bottom: 1.5rem;
  color: hsl(30 6% 70%);
}

/* Responsive padding for mobile nav */
@media (max-width: 768px) {
  .main-content {
    padding-top: 0.5rem;
    padding-bottom: calc(5rem + env(safe-area-inset-bottom));
  }
}

/* Desktop sidebar */
@media (min-width: 769px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 16rem;
    background: white;
    border-right: 1px solid hsl(30 6% 90%);
    padding: 1.5rem;
    z-index: 30;
  }

  .main-with-sidebar {
    margin-left: 16rem;
  }
}

/* Loading spinner */
.spinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid hsl(30 6% 90%);
  border-top-color: hsl(145 80% 20%);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD,sBAAsB;AACtB;EACE,iBAAiB;EACjB,sEAAsE;EACtE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,+EAA+E;EAC/E,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE;IACE,mBAAmB;IACnB,wDAAwD;EAC1D;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,sCAAsC;IACtC,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* App-specific styles - Fairway AI Golf Dashboard */\n\n/* Landing page hero */\n.hero-section {\n  min-height: 100vh;\n  background: linear-gradient(to bottom, hsl(60 5% 96%), hsl(60 5% 92%));\n  position: relative;\n  overflow: hidden;\n}\n\n.hero-image-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to bottom,\n    transparent 0%,\n    rgba(245, 245, 244, 0.4) 50%,\n    hsl(60 5% 96%) 100%\n  );\n  z-index: 1;\n}\n\n/* Dashboard layout */\n.dashboard-container {\n  min-height: 100vh;\n  background: hsl(60 5% 96%);\n}\n\n/* Nav styling */\n.nav-link {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  border-radius: 0.75rem;\n  font-weight: 500;\n  color: hsl(30 6% 35%);\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.nav-link:hover {\n  background: hsl(60 5% 92%);\n  color: hsl(145 80% 20%);\n}\n\n.nav-link.active {\n  background: hsl(145 80% 20%);\n  color: white;\n}\n\n/* Mobile bottom nav */\n.mobile-nav {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border-top: 1px solid hsl(30 6% 85%);\n  z-index: 40;\n  padding: 0.5rem;\n  padding-bottom: calc(0.5rem + env(safe-area-inset-bottom));\n}\n\n.mobile-nav-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.5rem;\n  font-size: 0.75rem;\n  color: hsl(30 6% 35%);\n  transition: color 0.2s ease;\n}\n\n.mobile-nav-item.active {\n  color: hsl(145 80% 20%);\n}\n\n/* Stat cards */\n.handicap-card {\n  grid-column: span 2;\n  background: linear-gradient(135deg, hsl(145 80% 20%) 0%, hsl(145 60% 25%) 100%);\n  color: white;\n}\n\n.handicap-value {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 4rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n/* Score entry form */\n.score-input {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 2rem;\n  font-weight: 600;\n  text-align: center;\n  width: 100%;\n  max-width: 8rem;\n  padding: 1rem;\n  border-radius: 1rem;\n  border: 2px solid hsl(30 6% 85%);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.score-input:focus {\n  outline: none;\n  border-color: hsl(145 80% 20%);\n  box-shadow: 0 0 0 4px hsla(145 80% 20% / 0.1);\n}\n\n/* Chart styling */\n.chart-container {\n  background: white;\n  border-radius: 1rem;\n  padding: 1.5rem;\n  border: 1px solid hsl(30 6% 90%);\n}\n\n/* Score history table */\n.score-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  background: white;\n  border-bottom: 1px solid hsl(30 6% 92%);\n  transition: background-color 0.2s ease;\n}\n\n.score-row:hover {\n  background: hsl(60 5% 98%);\n}\n\n.score-row:last-child {\n  border-bottom: none;\n}\n\n/* Score badge */\n.score-badge {\n  font-family: 'JetBrains Mono', monospace;\n  font-weight: 600;\n  padding: 0.375rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.875rem;\n}\n\n/* Empty state */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n}\n\n.empty-state-icon {\n  width: 4rem;\n  height: 4rem;\n  margin-bottom: 1.5rem;\n  color: hsl(30 6% 70%);\n}\n\n/* Responsive padding for mobile nav */\n@media (max-width: 768px) {\n  .main-content {\n    padding-top: 0.5rem;\n    padding-bottom: calc(5rem + env(safe-area-inset-bottom));\n  }\n}\n\n/* Desktop sidebar */\n@media (min-width: 769px) {\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 16rem;\n    background: white;\n    border-right: 1px solid hsl(30 6% 90%);\n    padding: 1.5rem;\n    z-index: 30;\n  }\n\n  .main-with-sidebar {\n    margin-left: 16rem;\n  }\n}\n\n/* Loading spinner */\n.spinner {\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid hsl(30 6% 90%);\n  border-top-color: hsl(145 80% 20%);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
